<template>
  <div class="homescreen">
    <div class="homescreensub">

    </div>
  </div>
</template>

<style>

.homescreen {
  padding: 0px;
  margin-left: 0px;
  color: #ffffff;
  background-color: #72bf44;
  max-width:inherit;
  overflow-y: hidden;
  position: relative;
  height: 100%;
  font-weight: bold;
  font-size: larger;

}

.homescreensub {
  padding: 0px;
  margin-left: 20px;
  color: #ffffff;
  background-color: #003950;
  max-width:inherit;
  overflow-y: hidden;
  position: relative;
  height: 100%;
  font-weight: bold;
  font-size: larger;

}

</style>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    HelloWorld
  }
}
</script>
